<!-- Modal Container Minimalista -->
<div class="min-h-screen py-6">
  <div class="max-w-3xl mx-auto px-4 sm:px-6">
    
    <!-- Header Simple -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
      <div class="px-6 py-4">
        <div class="flex items-center space-x-3">
          <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
            <i class="fas fa-tags text-blue-600 text-sm"></i>
          </div>
          <div>
            <h1 class="text-lg font-semibold text-gray-900">Gestión de Etiquetas</h1>
            <p class="text-sm text-gray-500">Administra las etiquetas de la persona</p>
          </div>
        </div>
                    </div>
                </div>

    <!-- Sección de Búsqueda -->
    <div data-rbac-permiso="planes.etiquetas.read planes.etiquetas.assign" class="bg-white rounded-lg shadow-sm border border-gray-200 mb-6" *ngIf="!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['planes.etiquetas.read', 'planes.etiquetas.assign'])">
      <div class="px-6 py-4">
        <div class="flex items-center space-x-3 mb-4">
          <i class="fas fa-search text-gray-400"></i>
          <h2 class="text-md font-medium text-gray-900">Buscar Etiquetas</h2>
        </div>
        
        <!-- Input de Búsqueda -->
                            <div class="relative">
          <input 
            type="text" 
            id="search-input"
            class="block w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 placeholder-gray-400"
            placeholder="Buscar etiquetas disponibles..."
            (focus)="searchOpen()"
            (input)="searchCode($event)"
            autocomplete="off">
          
          <!-- Dropdown de Autocompletado -->
          <div 
            *ngIf="openSearch && filteredCodesList.length > 0" 
            class="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto custom-scrollbar">
            <div class="py-1">
              <div 
                                    *ngFor="let item of filteredCodesList"
                class="px-4 py-3 hover:bg-blue-50 cursor-pointer transition-colors duration-150 border-b border-gray-50 last:border-b-0"
                (click)="selectCode(item)">
                <div class="flex items-center justify-between">
                  <div>
                    <div class="text-sm font-medium text-gray-900">{{item.code}}</div>
                    <div class="text-xs text-gray-500">{{item.name}}</div>
                  </div>
                  <i class="fas fa-plus text-blue-500 text-xs"></i>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Mensaje Sin Resultados -->
          <div 
            *ngIf="openSearch && filteredCodesList.length === 0 && searchTerm.trim()" 
            class="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg">
            <div class="px-4 py-6 text-center">
              <i class="fas fa-search text-gray-300 text-lg mb-2"></i>
              <p class="text-sm text-gray-500">No se encontraron etiquetas</p>
            </div>
          </div>
        </div>
        
        <!-- Botón Agregar -->
        <div class="mt-4 flex justify-between items-center" *ngIf="selectedItem">
          <div class="flex items-center space-x-2 text-sm text-gray-600">
            <i class="fas fa-info-circle"></i>
            <span>Seleccionado: <strong>{{selectedItem.code}} - {{selectedItem.name}}</strong></span>
          </div>
          <div class="flex space-x-2">
            <button 
              type="button" 
              (click)="clearSelection()" 
              class="px-3 py-2 text-sm text-gray-600 hover:text-gray-800 transition-colors duration-200">
              Cancelar
            </button>
            <button 
              type="button" 
              (click)="addCode()" 
              [disabled]="loadingAdd"
              class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 disabled:opacity-50">
              <i class="fas fa-spinner fa-spin mr-2" *ngIf="loadingAdd"></i>
              <i class="fas fa-plus mr-2" *ngIf="!loadingAdd"></i>
              {{loadingAdd ? 'Agregando...' : 'Agregar'}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Mensaje cuando no tiene permiso de etiquetas -->
    <div *ngIf="_auth.hasRbac$.getValue() && !_auth.hasAnyPermission(['planes.etiquetas.read', 'planes.etiquetas.assign', 'planes.etiquetas.delete'])" class="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
      <div class="px-6 py-8 text-center">
        <i class="fas fa-lock text-gray-300 text-2xl mb-3"></i>
        <p class="text-sm text-gray-500">No tienes permisos para gestionar etiquetas</p>
      </div>
    </div>

    <!-- Sección de Etiquetas Asignadas -->
    <div data-rbac-permiso="planes.etiquetas.read" class="bg-white rounded-lg shadow-sm border border-gray-200" *ngIf="!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['planes.etiquetas.read'])">
      <div class="px-6 py-4 border-b border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <i class="fas fa-tags text-gray-400"></i>
            <h2 class="text-md font-medium text-gray-900">Etiquetas Asignadas</h2>
          </div>
          <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            {{personDinamicCode?.length || 0}}
                                    </span>
        </div>
      </div>
      
      <div class="px-6 py-4">
        <!-- Estado de Carga -->
        <div *ngIf="loading" class="flex items-center justify-center py-8">
          <div class="flex items-center space-x-3">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
            <span class="text-sm text-gray-500">Cargando etiquetas...</span>
          </div>
                          </div>

        <!-- Estado Vacío -->
        <div *ngIf="!loading && personDinamicCode?.length === 0" class="text-center py-8">
          <i class="fas fa-tags text-gray-300 text-2xl mb-3"></i>
          <h3 class="text-sm font-medium text-gray-900 mb-2">No hay etiquetas asignadas</h3>
          <p class="text-sm text-gray-500">Busca y selecciona etiquetas para agregar</p>
                    </div>
        
        <!-- Cintillos de Etiquetas -->
        <div *ngIf="!loading && personDinamicCode?.length > 0" class="flex flex-wrap gap-2">
          <div 
            *ngFor="let item of personDinamicCode"
            class="group inline-flex items-center bg-gray-100 hover:bg-gray-200 rounded-full px-3 py-1.5 text-sm transition-all duration-200">
            
            <!-- Icono de Etiqueta -->
            <i class="fas fa-tag text-gray-500 text-xs mr-2"></i>
            
            <!-- Código de la Etiqueta -->
            <span class="font-medium text-gray-700 mr-1">{{item?.code}}</span>
            
            <!-- Separador -->
            <span class="text-gray-400 mr-1">-</span>
            
            <!-- Nombre de la Etiqueta -->
            <span class="text-gray-600 mr-2">{{item?.name}}</span>
            
            <!-- Botón Eliminar -->
            <button data-rbac-permiso="planes.etiquetas.delete" 
              *ngIf="!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['planes.etiquetas.delete'])"
              (click)="deleteCodePerson(item?.code)"
              class="tag-delete-btn text-red-400 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
              title="Eliminar etiqueta">
              <i class="fas fa-times text-xs"></i>
                        </button>
                    </div>
                </div>
            </div>

      <!-- Footer Info -->
      <div class="px-6 py-3 bg-gray-50 border-t border-gray-200 rounded-b-lg" *ngIf="!loading">
        <div class="flex items-center justify-between text-xs text-gray-500">
          <span>
            <i class="fas fa-info-circle mr-1"></i>
            Pasa el cursor sobre una etiqueta para eliminarla
                        </span>
          <span>
            <i class="fas fa-keyboard mr-1"></i>
            Usa el buscador para agregar más etiquetas
                </span>
        </div>
        </div>
    </div>
  </div>
</div>
